var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-house 1",
    clipPath: "url(#clip0_24_7584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3496 21.9365H31.3123V51.6125H16.3496V21.9365Z",
    fill: "#F3F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.2764 25.6768H31.3125V51.6121H25.2764V25.6768Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.8087 25.6771H14.8534C14.3024 25.6771 13.856 25.2304 13.856 24.6796V19.1933C13.856 18.6423 14.3026 18.1958 14.8534 18.1958H32.8087C33.3597 18.1958 33.8062 18.6425 33.8062 19.1933V24.6796C33.8062 25.2304 33.3597 25.6771 32.8087 25.6771Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.8086 18.1953H26.7725C27.3234 18.1953 27.7699 18.6418 27.7699 19.1928V24.6791C27.7699 25.2301 27.3232 25.6766 26.7725 25.6766H32.8086C33.3596 25.6766 33.8061 25.2299 33.8061 24.6791V19.1928C33.8061 18.642 33.3596 18.1953 32.8086 18.1953Z",
    fill: "#D83131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M87.9211 96.8342H13.1074V53.7205L50.5143 25.0107L87.9211 53.7182V96.8342Z",
    fill: "#F3F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M81.8848 49.0859V96.8344H87.9211V53.7184L81.8848 49.0859Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M95.6849 54.712L52.792 21.794C51.4486 20.7633 49.5805 20.7633 48.2371 21.794L5.34432 54.712C3.70546 55.9698 3.39647 58.318 4.65409 59.9569C5.9119 61.5956 8.26014 61.9045 9.89901 60.6471L50.5144 29.477L91.1301 60.6469C91.8093 61.168 92.6099 61.4204 93.4049 61.4204C94.5277 61.4202 95.6385 60.9165 96.3752 59.9569C97.6328 58.318 97.3238 55.9698 95.6849 54.712Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.8311 64.8057H46.2752V96.8342H23.8311V64.8057Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.2388 64.8057H46.2749V96.8342H40.2388V64.8057Z",
    fill: "#D83131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M46.275 63.3413H23.8311C23.0221 63.3413 22.3662 63.997 22.3662 64.8062V96.8345C22.3662 97.6437 23.0221 98.2993 23.8311 98.2993C24.64 98.2993 25.2959 97.6437 25.2959 96.8345V66.271H44.8104V96.8345C44.8104 97.6437 45.4662 98.2993 46.2752 98.2993C47.0842 98.2993 47.74 97.6437 47.74 96.8345V64.8062C47.7398 63.997 47.084 63.3413 46.275 63.3413Z",
    fill: "#7A6D79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M55.2529 64.8057H77.1982V79.7684H55.2529V64.8057Z",
    fill: "#A6E7F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M71.1616 64.8057H77.1978V79.7684H71.1616V64.8057Z",
    fill: "#6BD9E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M77.1982 63.3413H55.2529C54.4437 63.3413 53.7881 63.997 53.7881 64.8062V79.7687C53.7881 80.5778 54.4437 81.2335 55.2529 81.2335H77.1982C78.0074 81.2335 78.6631 80.5778 78.6631 79.7687V64.8062C78.6631 63.997 78.0072 63.3413 77.1982 63.3413ZM56.7178 66.271H64.7607V78.3038H56.7178V66.271ZM75.7334 78.3038H67.6902V66.271H75.7334V78.3038Z",
    fill: "#7A6D79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M40.0405 79.1572C39.2315 79.1572 38.5757 79.8129 38.5757 80.6221V82.617C38.5757 83.4262 39.2315 84.0818 40.0405 84.0818C40.8495 84.0818 41.5054 83.4262 41.5054 82.617V80.6221C41.5054 79.8131 40.8495 79.1572 40.0405 79.1572Z",
    fill: "#F3F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M57.5257 54.1587H44.3224C43.1021 54.1587 42.1128 53.1694 42.1128 51.9491V47.1231C42.1128 45.9028 43.1021 44.9136 44.3224 44.9136H57.5257C58.746 44.9136 59.7353 45.9028 59.7353 47.1231V51.9491C59.7353 53.1694 58.746 54.1587 57.5257 54.1587Z",
    fill: "#A6E7F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M57.5259 44.9131H51.4897C52.7101 44.9131 53.6993 45.9023 53.6993 47.1227V51.9486C53.6993 53.1689 52.7101 54.1582 51.4897 54.1582H57.5259C58.7462 54.1582 59.7354 53.1689 59.7354 51.9486V47.1227C59.7354 45.9023 58.7462 44.9131 57.5259 44.9131Z",
    fill: "#6BD9E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M57.5257 43.4482H44.3224C42.2962 43.4482 40.6479 45.0965 40.6479 47.1227V51.9486C40.6479 53.9748 42.2964 55.623 44.3224 55.623H57.5257C59.5519 55.623 61.2001 53.9748 61.2001 51.9486V47.1227C61.2003 45.0967 59.5519 43.4482 57.5257 43.4482ZM58.2706 51.9488C58.2706 52.3596 57.9364 52.6936 57.5259 52.6936H44.3226C43.9118 52.6936 43.5778 52.3594 43.5778 51.9488V47.1229C43.5778 46.7121 43.912 46.3781 44.3226 46.3781H57.5259C57.9366 46.3781 58.2706 46.7123 58.2706 47.1229V51.9488Z",
    fill: "#7A6D79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M96.9818 100H3.01816C1.35117 100 0 98.649 0 96.982C0 95.3152 1.35117 93.9639 3.01816 93.9639H96.982C98.6488 93.9639 100 95.315 100 96.982C100 98.649 98.6488 100 96.9818 100Z",
    fill: "#7A6D79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M96.9819 93.9639H90.9458C92.6126 93.9639 93.964 95.3152 93.964 96.982C93.964 98.6488 92.6128 100 90.9458 100H96.9819C98.6487 100 100 98.6488 100 96.982C100 95.315 98.6489 93.9639 96.9819 93.9639Z",
    fill: "#685E68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M84.2838 1.62661L86.1756 5.45845C86.4619 6.03853 87.0156 6.44067 87.6558 6.53364L91.8861 7.1481C94.2797 7.49575 95.2355 10.4362 93.5035 12.1239L90.4424 15.1065C89.9791 15.5581 89.7675 16.2086 89.8769 16.8461L90.5996 21.0579C91.0084 23.4409 88.5062 25.2583 86.3654 24.1331L82.5818 22.1446C82.009 21.8436 81.3248 21.8436 80.7519 22.1446L76.9683 24.1331C74.8275 25.2583 72.3254 23.4409 72.7341 21.0579L73.4568 16.8461C73.5662 16.2086 73.3547 15.5581 72.8914 15.1065L69.8302 12.1239C68.0982 10.4362 69.0541 7.49575 71.4476 7.1481L75.6779 6.53364C76.3183 6.44067 76.8718 6.03853 77.1582 5.45845L79.05 1.62661C80.1205 -0.541553 83.2132 -0.541553 84.2838 1.62661Z",
    fill: "#FFDE5C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M93.5033 12.1239C95.2354 10.4362 94.2797 7.49575 91.8861 7.1481L87.6559 6.53364C87.0154 6.44067 86.4619 6.03853 86.1756 5.45845L84.2838 1.62661C83.2133 -0.541553 80.1205 -0.541553 79.05 1.62661L78.2617 3.22349L80.1395 7.02681C80.4258 7.60688 80.9795 8.00884 81.6197 8.102L85.85 8.71645C88.2436 9.06411 89.1994 12.0045 87.4672 13.6922L84.4061 16.675C83.9428 17.1266 83.7313 17.7772 83.8406 18.4147L84.5633 22.6264C84.5975 22.8249 84.6094 23.019 84.6051 23.2081L86.3654 24.1332C88.5062 25.2584 91.0086 23.4411 90.5996 21.0581L89.877 16.8463C89.7676 16.2088 89.9791 15.5583 90.4424 15.1067L93.5033 12.1239Z",
    fill: "#FFC344"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_7584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.f7d96fdfd948e61dbbf876f9b718218e.svg";
export { ForwardRef as ReactComponent };